import type { ReactNode } from 'react';
import { createContext } from 'react';
import type { ContextValue } from 'react-aria-components';

import type { IconProps } from './types';

export type IconContextValue = {
  /**
   * Wrap the element with some custom behaviour, within a slotted component.
   */
  render?: (icon: ReactNode) => ReactNode;
} & IconProps;

export const IconContext = createContext<
  ContextValue<IconContextValue, SVGSVGElement>
>({});
